import { Controller } from "@hotwired/stimulus"

// Commit E (Discovery Line, plan section 3): the outreach desk's per-row
// "Did you send it?" flow. Clicking the channel-first Open link lets the
// new tab open normally and reveals the question; Yes submits the same
// one-press log form the "Log a send" button uses; No just clears the
// question (client-side state only, nothing to persist about a question).
export default class extends Controller {
  static targets = ["question", "logForm"]

  opened() {
    if (this.hasQuestionTarget) this.questionTarget.hidden = false
  }

  confirmSend() {
    if (this.hasLogFormTarget) this.logFormTarget.requestSubmit()
  }

  dismiss() {
    if (this.hasQuestionTarget) this.questionTarget.hidden = true
  }
}
